module.exports = __webpack_public_path__ + "static/media/icon_169.f442ddc2.svg";